<template>
  <div class="home">
      <video id="video" autoplay width="100%" height="100%"></video>
  </div>
</template>
<script>
import "./util/webrtcstreamer.js" //此处两个js也可全局引用
import "./util/adapter.min.js"
export default {
  name: "HomeView",
  data() {
      return {
          webRtcServer: null,
          webRtcServer1: null
      };
  },
  props: {
    spbfdz: {
      type: String,
      default: '',
    }
  },
  watch: {
    spbfdz(val) {
        this.$nextTick(() => {
            console.log("进入视频")
            this.playVideo();
        });
      }
    },
  mounted() {
     
  },
  methods: {
      playVideo() {
        console.log(this.spbfdz)
          this.webRtcServer = new WebRtcStreamer(
              "video",
              'http://192.168.102.2:8000'//本机ip+端口8000
          );

          this.webRtcServer.connect(this.spbfdz);
      }

  },
  beforeDestroy() {
      this.webRtcServer.disconnect();
      this.webRtcServer = null;
  }
};
</script>



// WEBPACK FOOTER //
// src/common/video/WebVideoRtsp.vue